/**
 * [CRO] Out-of-stock similar products
 *
 * Fetches related products via Shopify's recommendations API, filters to
 * available items only, renders up to 5 card-style entries.
 *
 * WHERE TO PUT THIS FILE: assets/oos-similar-products.js
 *
 * HOW TO LOAD: Add this line to layout/theme.liquid just before </head>:
 *   <script src="{{ 'oos-similar-products.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  'use strict';

  function initOOSSimilar() {
    const containers = document.querySelectorAll('[data-oos-similar]');
    if (containers.length === 0) return;

    containers.forEach((container) => {
      // Skip if already initialized
      if (container.dataset.oosInitialized === 'true') return;
      container.dataset.oosInitialized = 'true';

      const productId = container.dataset.productId;
      const grid = container.querySelector('[data-oos-grid]');
      if (!productId || !grid) return;

      // Request more than we need so we can filter out unavailable items
      fetch(`/recommendations/products.json?product_id=${productId}&limit=12&intent=related`)
        .then((res) => res.json())
        .then((data) => {
          const products = data.products || [];
          const available = products.filter((p) => p.available).slice(0, 5);

          if (available.length === 0) {
            container.style.display = 'none';
            return;
          }

          grid.innerHTML = available.map(buildCardHTML).join('');
        })
        .catch(() => {
          container.style.display = 'none';
        });
    });
  }

  function buildCardHTML(product) {
    const imageUrl = product.featured_image
      ? appendImageSize(product.featured_image, '400x')
      : '';
    const title = escapeHtml(product.title);
    const price = formatMoney(product.price);

    return `
      <a href="${product.url}" class="oos-similar-card" data-oos-card>
        <div class="oos-similar-card__image">
          ${imageUrl ? `<img src="${imageUrl}" alt="${title}" loading="lazy">` : ''}
        </div>
        <p class="oos-similar-card__title">${title}</p>
        <p class="oos-similar-card__price">${price}</p>
      </a>
    `;
  }

  function appendImageSize(url, size) {
    return url.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, `_${size}$1$3`);
  }

   function formatMoney(cents) {
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    var cfg = window.themeCurrency || {};
    var L = cfg.locale || 'en-US';
    var C = cfg.currency || 'USD';
    try {
      return (cents / 100).toLocaleString(L, { style: 'currency', currency: C });
    } catch (e) {
      return C + ' ' + (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[c]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOOSSimilar);
  } else {
    initOOSSimilar();
  }

  // Theme Editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initOOSSimilar);
  }
})();